import React, { Component, useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import LoginForm from "../LoginForm/LoginForm";
import { Div, Img, Form, DivImg, DivRow, Box, Container, Row, Column, FooterLink, Heading, } from "./LoginPage.styles";
import { Carousel } from 'primereact/carousel';
import Base64Downloader from 'common-base64-downloader-react';
import "./LoginPage.css";
import apis from '../../../api';
import TermsModal from "../../../components/TermsModal/TermsModal";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : LoginPage
Description : Componente que contienen el formulario de Login y la imagen de la pantalla login
Date Autor Modification
================================================================================
1/10/2021 Cristian Andres Pizo Mina – Se llama al componente LoginForm
================================================================================ */
export default function LoginPage() {
    const [tiempo, setTiempo] = useState(300);

    setTimeout(function () {
        console.log('hola');
        setTiempo(400);
    }, 3000)

    console.log()

    const products = [
        {
            id: 0,
            image: localStorage.getItem('LOGIN_VIDEO'),
            name: 'Remuner',
            type: 'vid'
        },
        {
            id: 1,
            image: process.env.REACT_APP_BANNER_IMAGE_1,
            name: 'Remuner',
            type: 'img'
        },
        {
            id: 2,
            image: process.env.REACT_APP_BANNER_IMAGE_2,
            name: 'Remuner',
            type: 'img'
        },
        {
            id: 3,
            image: process.env.REACT_APP_BANNER_IMAGE_3,
            name: 'Remuner',
            type: 'img'
        }
    ]

    const productTemplate = (product) => {
        return (
            <div className="product-item">
                <div className="product-item-content">
                    <div className="mb-3">
                        {
                            product.type === 'img' ?
                                <a href="#" target="_blank" rel="noopener noreferrer">
                                    <Img src={product.image} alt={product.name} />
                                </a>
                                :
                                <div className='w-18rem align-content-end pb-0 -mr-6'>
                                    <iframe
                                        width="840"
                                        height="460"
                                        style={{ marginTop: '3rem', marginBottom: '-2rem' }}
                                        src={product.image}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        title="Embedded youtube"
                                    />
                                </div>
                        }
                    </div>
                </div>
            </div>
        );
    }


    const time = () => {

        console.log('tiempo')
        return 3000;
    }

    return (
        <div style={{ top: "0", height: "30%" }}>
            <Div style={{ backgroundColor: "white" }}>
                <div className="container">
                    <DivRow>
                        <div className="carousel-demo">
                            <div style={{ marginLeft: "-6rem" }} className="card">
                                <Carousel value={products} numVisible={1} numScroll={1} circular
                                    autoplayInterval={3000} itemTemplate={productTemplate} header={false} />
                            </div>
                        </div>
                        <Form>
                            <LoginForm className="mr-4 login" />
                        </Form>
                    </DivRow>
                </div>
            </Div>
            <div style={{ marginTop: "2rem" }}>
                <span className="font-semibold">Powered By Vibe Consulting &#169;</span>
            </div>
        </div>
    )
}